<template>
    <fieldset id="capacity-filter">
        <legend>Plads</legend>
        <label for="minpers" class="muted">Min. personer</label>
        <div class="range">
            <input 
                type="range" 
                id="minpers" 
                :min="range_min"
                :max="range_max"
                v-model="capacity_min"
                @change="emitChange()">
            <span class="indicator">{{ capacity_min }}</span>
        </div>
        <label for="maxpers" class="muted">Max. personer</label>
        <div class="range">
            <input 
                type="range" 
                id="maxpers" 
                :min="range_min" 
                :max="range_max"
                v-model="capacity_max"
                @change="emitChange()">
            <span class="indicator">{{ capacity_max }}</span>
        </div>
    </fieldset>
</template>

<script>

    export default {
        data: function() {
            return {
                range_min: 0,
                range_max: 200,
                capacity_min: 0,
                capacity_max: 200
            }
        },
        methods: {
            emitChange: function() {
                this.$emit('filter', { 
                    'capacity__gte': this.capacity_min,
                    'capacity__lte': this.capacity_max
                })
            }
        }
    }

</script>

<style lang="scss">

    #capacity-filter {
        
        .range {
            display: flex;
            align-items: center;
        }
        input {
            padding: .25rem;
        }
        .indicator {
            padding: 0 .5rem;
        }
    }

</style>